const enum Speed {
  Walk = .08,
  Run = .12
}
export default Speed;